import type { AutocompleteProps as MuiAutocompleteProps } from '@mui/material';
import type {
  HTMLAttributes,
  SyntheticEvent,
} from 'react';

import type {
  FormSelectOption,
  GenericFormField,
} from '../GenericForm/index.js';
import { Input } from '../Input/index.js';
import {
  autocompleteListBoxStyles,
  AutocompletePaper,
  StyledAutocomplete,
} from './Autocomplete.styled.js';

interface AutocompleteProps {
  field: GenericFormField;
  value: string;
  disabled?: boolean;
  renderOption?: MuiAutocompleteProps<any, any, any, any, any>['renderOption'];
  onChange?: (event: SyntheticEvent<Element, Event>, value: any) => void;
  groupBy?: (option: any) => string;
}

export const Autocomplete = ({
  field,
  onChange,
  value,
  groupBy,
  disabled,
  renderOption,
}: AutocompleteProps) => {
  return (
    <StyledAutocomplete
      options={field?.options ?? []}
      clearIcon={null}
      value={
        (field?.options ?? []).find(option => option.value === value) ?? ''
      }
      disabled={disabled}
      onChange={onChange}
      groupBy={groupBy}
      getOptionLabel={option => (option as FormSelectOption)?.label ?? ''}
      slots={{ paper: AutocompletePaper }}
      slotProps={{
        listbox: { sx: autocompleteListBoxStyles } as HTMLAttributes<HTMLUListElement>,
      }}
      renderOption={renderOption}
      renderInput={props => (
        <Input
          {...props}
          placeholder={field?.placeholder ?? ''}
          variant="outlined"
          margin="none"
          fullWidth
        />
      )}
    />
  );
};
